<template>
  <div>
    <main class="main-content">
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="card-title">جدول مدیر داخلی(پروژه های درحال اجرا)</h6>
          </div>
          <div class="d-flex justify-content-center height" v-if="data==null" >
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">در حال بارگذاری ...</span>
            </div>
          </div>
          <div class="table-responsive" v-for="(project, index) in data" :key="index">
            <board :project="project" :materials="materials" :statuses="statuses" :installers="installers" :counter="index+1"/>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import board from '@/components/board.vue'
export default {
  name: 'whiteBoard',
  components: {
    board
  },
  data () {
    return {
      data: null,
      url: 'api/project/whiteBoard',
      type: 'get',
      statuses: null,
      materials: null,
      installers: null
    }
  },
  mounted () {
    this.startMethod()
    this.$send.submit('get', 'api/project/whiteBoard')
      .then(response => {
        this.data = response
      })
  },
  methods: {
    startMethod () {
      this.$send.submit('get', 'api/material/status')
        .then(response => {
          this.statuses = response
        })
      this.$send.submit('get', 'api/get/materials')
        .then(response => {
          this.materials = response
        })
      this.$send.submit('get', 'api/get/installers')
        .then(response => {
          this.installers = response
        })
    }
  }
}
</script>
